import Cotizador from "../../components/cotizador/Cotizador";
import Servicios from "../../components/servicios/Servicios";
import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import Faqs from "../../components/Faqs/Accordion";
import Nosotros from "../../components/nosotros/Nosotros";
import Banner from "./Banner";
import Video from "../../components/video/Video";
import BrandCarousel from "../../components/clientes/BrandCarousel";
     // <Cotizador />
     // <BrandCarousel />
export default function Home() {
  return (
    <Layout>
      <Navbar darkBg />
      <Banner />
      <Nosotros />
      <Servicios />
      <Video />
      <Faqs />

      <Footer />
    </Layout>
  );
}
